module.exports = __webpack_public_path__ + "img/shortcut_service_off.40325103.svg";